export interface UpdateTopic {

  programid: String,
  topicid: String,
  userId: String,
  alltime: String,
  readingtime: String,
  readingdate: Date
}export class UpdateTopic {

  constructor(

    public programid: String,
    public topicid: String,
    public userId: String,
    public alltime: String,
    public readingtime: String,
    public readingdate: Date
  ) { }

}
